import { ProfileAdminSettings } from '../../../../admin/admin.model';

/** Collect Payment views that never take an invoice selection. */
const NON_SELECTION_VIEWS = new Set(['completeAuth', 'refund', 'adjust', 'flashpay', 'onetimepay']);

/**
 * Whether Collect Payment's invoice step is forced into multi-invoice ("Customer Balance") mode:
 * either the profile uses invoices but has adhoc auto-gen off, so only existing invoices may be paid,
 * and the route's `view` is not one that never takes an invoice selection; or it is the Advanced
 * FlashPay view, which sends a selection of existing invoices.
 *
 * Decided from settings and the route alone, so `CollectComponent` can title the step before the
 * invoice-details child has initialised. Reading the child's own flag from the parent's template
 * changed it mid-render (NG0100). The child applies the same rule when it switches.
 */
export function isMultiInvoiceModeForced(
  settings: Partial<ProfileAdminSettings> | null | undefined,
  view: string | null | undefined
): boolean {
  const adhocAllowed = !(settings?.enableInvoice && !settings?.enableAdhocInvoiceAutoGen);
  return (
    (!!settings?.enableInvoice && !adhocAllowed && !NON_SELECTION_VIEWS.has(view ?? '')) ||
    isAdvancedFlashPayView(settings, view)
  );
}

/**
 * Advanced FlashPay: the FlashPay view on a profile with `enableAdvancedFlashPay` and invoices. The
 * user selects existing open invoices (Multiple Invoices, forced) and sends them as one email
 * instead of typing a single invoice.
 */
export function isAdvancedFlashPayView(
  settings: Partial<ProfileAdminSettings> | null | undefined,
  view: string | null | undefined
): boolean {
  return view === 'flashpay' && settings?.enableAdvancedFlashPay === true && settings?.enableInvoice === true;
}
